<template>
  <div class="newg_form" style="overflow-x:hidden" 
                @mouseover="tooltipCode()">
    <div
      v-show="showLoader"
      class="spinner-border"
      style="margin: auto; display: block"
    ></div>
    <form v-show="!showLoader" v-on:submit.prevent class="main_form_block">
      <div style="padding-top: 20px">
        <div class="form-group row">
          <label for="title" class="col-sm-2"
            >Guardrail Title <sup>*</sup></label
          >
          <div style="padding-right: 0px" class="col-sm-4">
            <span v-if="nameValidation" class="no-data-style" style=""
              >Provide the required field</span
            >
            <input
              style=""
              @click="toggleValidation"
              type="text"
              placeholder="Title"
              required="true"
              v-model="title"
              class="form-control custom-placeholder input-overview"
              id="dailyBudget"
            />
          </div>
        </div>
        
        <div
          class="form-group row"
          style="margin-top: 36px; margin-bottom: 0px"
        >
          <div class="col-sm-2" style="padding-right: 0px">
            <label style="padding: 0px">Target Measure <sup>*</sup></label>
          </div>
          <div class="row col-sm-9" v-if="sourceList">
            <span v-if="targetValidation" class="no-data-style col-sm-12" style=""
              >Provide the required field</span
            >
            <div
              class="option_box ml-3"
              @click="getTargetTypeList(item)"
              v-for="item in sourceList"
              :key="item.name"
              :class="[
                source && source.name == item.name ? 'selected' : '',
                (automationId && automationId != 'null'||(calledFrom)) ? 'block_events' : '',
              ]"
            >
              <p
                class="inner_text"
                :class="source && source.name == item.name ? 'selected' : ''"
              >
                {{ item["name"] }}
              </p>
            </div>
            
          </div>
        </div>
        <div
          v-if="isShowTargetMeasure && source"
          style="margin-top: 28px; margin-bottom: 0px"
        >
          <div
            v-if="conditionValidation"
            class="form-group row"
            style="padding-left: 17px"
          >
            <div class="col-md-2"></div>
            <span class="no-data-style">Make a selection to proceed</span>
          </div>

          <template v-for="(item, index) in conditionList">
            <div :key="'prefilledActions_' + index" class="form-group row" style="margin-bottom:0px" :style="index==0?'':'margin-top:19px'">
              <div class="col-sm-2"></div>
              <div class="col-sm-10">
                <div class="form-group row" style="margin-bottom:0px">
                  <div class="col-md-4">
                    <multiselect
                      v-model="item.type"
                      class="
                        form-control
                        multi-dropdown
                        select_filter
                        multiselect-overview
                      "
                      placeholder="Type"
                      label="name"
                      deselectLabel
                      selectedLabel
                      selectLabel
                      :disabled="disableTheSelected[index]"
                      :options="
                        remainingTypeListToShow ? remainingTypeListToShow : []
                      "
                      track-by="id"
                      ref="multiselect"
                      @input="getTargetTypedata(item.type, index, item)"
                      @remove="removeTarget"
                      :multiple="false"
                      :taggable="false"
                      style="height: 0px"
                    ></multiselect>
                  </div>
                  <div
                    class="col-md-2"
                    v-if="item.type && !item.type.action"
                    style="padding: 0px"
                  >
                    <multiselect
                      @input="toggleValidation"
                      v-model="item.condition"
                      class="
                        form-control
                        multi-dropdown
                        select_filter
                        multiselect-overview
                      "
                      placeholder="Select"
                      label="name"
                      deselectLabel
                      selectedLabel
                      selectLabel
                      :disabled="disableTheSelected[index]"
                      :options="(item.type ? (conditionalRange? conditionalRange:[]):[])"
                      track-by="id"
                      ref="multiselect"
                      :multiple="false"
                      :taggable="false"
                      @select="onSelectRange(item)"
                      style="height: 0px"
                      v-if="item.type && item.type.id && item.type.id=='global_rating_count_decrease'"
                    ></multiselect>
                    <multiselect
                      v-else
                      @input="toggleValidation"
                      v-model="item.condition"
                      class="
                        form-control
                        multi-dropdown
                        select_filter
                        multiselect-overview
                      "
                      placeholder="Select"
                      label="name"
                      deselectLabel
                      selectedLabel
                      selectLabel
                      :disabled="disableTheSelected[index]"
                      :options="
                        remainingTypeListToShow.length > 0
                          ? rangeList
                            ? rangeList
                            : []
                          : []
                      "
                      track-by="id"
                      ref="multiselect"
                      :multiple="false"
                      :taggable="false"
                      @select="onSelectRange(item)"
                      style="height: 0px"
                    ></multiselect>
                  </div>
                  <div
                    v-if="
                      item.type &&
                      item.type.attr_data_type &&
                      item.type.attr_data_type == 'text' &&
                      item.condition.id != 'ispresent' &&
                      item.condition.id != 'isnotpresent'
                    "
                    class="col-md-3"
                    style="padding-right: 0px"
                  >
                    <input
                      style="min-height: calc(1.5em + 0.75rem + 6px)"
                      type="text"
                      placeholder="Text"
                      @click="toggleValidation"
                      required="true"
                      :disabled="
                        remainingTypeListToShow.length > 0
                          ? disableTheSelected[index]
                          : true
                      "
                      v-model="item.value"
                      class="form-control"
                      id="dailyBudget"
                    />
                  </div>
                  <div
                    v-if="
                      item.type &&
                      item.type.attr_data_type &&
                      item.type.attr_data_type == 'single-select'
                    "
                    class="col-md-3"
                    style="padding-right: 0px"
                  >
                    <multiselect
                      v-model="item.value"
                      :options="valueList"
                      ref="multiselect"
                      label="name"
                      track-by="name"
                      @tag="addValue($event, index)"
                      open-direction="bottom"
                      :taggable="true"
                      :disabled="
                        remainingTypeListToShow.length > 0
                          ? disableTheSelected[index]
                          : true
                      "
                      placeholder="Type"
                      class="
                        form-control
                        multi-dropdown
                        select_filter
                        multiselect-overview
                      "
                      selectLabel
                      deselectLabel
                      selectedLabel
                      :multiple="true"
                      @input="resetValue(item.value, index)"
                      style="height: 0px"
                    >
                    </multiselect>
                  </div>
                  <div
                    v-if="
                      item.type &&
                      item.type.attr_data_type &&
                      item.type.id == 'country' &&
                      item.type.attr_data_type == 'multiselect'
                    "
                    class="col-md-3"
                    style="padding-right: 0px"
                  >
                    <multiselect
                      @input="toggleValidation"
                      v-model="item.value"
                      :options="countryList"
                      :searchable="true"
                      :loading="tagSearchLoader"
                      ref="multiselect"
                      label="country_code"
                      track-by="country_code"
                      open-direction="bottom"
                      placeholder="Country Code"
                      class="
                        form-control
                        multi-dropdown
                        col-md-12
                        select_filter
                        multiselect-overview
                      "
                      style="max-height: 42px"
                      id="countryData"
                      :closeOnSelect="true"
                      :multiple="true"
                      :disabled="
                        remainingTypeListToShow.length > 0
                          ? disableTheSelected[index]
                          : true
                      "
                    ></multiselect>
                  </div>
                  <div
                    v-if="getValueTypeUrlLoader"
                    class="spinner-border"
                    style="margin-left: 30px; display: block"
                  ></div>
                  <div
                    v-if="
                      item.type &&
                      item.type.id != 'country' &&
                      item.type.attr_data_type &&
                      (item.type.attr_data_type == 'multiselect' ||
                        item.type.attr_data_type == 'singleselect') &&
                      !getValueTypeUrlLoader
                    "
                    class="col-md-3"
                    style="padding-right: 0px"
                  >
                    <multiselect
                      v-model="item.value"
                      class="
                        form-control
                        multi-dropdown
                        select_filter
                        multiselect-overview
                      "
                      placeholder="Type"
                      label="name"
                      deselectLabel
                      selectedLabel
                      selectLabel
                      :disabled="
                        remainingTypeListToShow.length > 0
                          ? disableTheSelected[index]
                          : true
                      "
                      :options="valueList"
                      track-by="name"
                      ref="multiselect"
                      @tag="
                        addMultiValue($event, index, item.type.attr_data_type)
                      "
                      :multiple="true"
                      openDirection="bottom"
                      :taggable="true"
                      @select="
                        item.type.attr_data_type == 'singleselect'
                          ? updateSingleValue($event, index)
                          : ''
                      "
                    ></multiselect>
                  </div>
                  <div
                    v-if="
                      item.type &&
                      item.type.attr_data_type &&
                      item.type.attr_data_type == 'number'
                    "
                    :class="
                      item.condition.id == 'range' ||
                      item.condition.id == 'notinrange'
                        ? 'col-md-1'
                        : 'col-md-3'
                    "
                    style="padding-right: 0px"
                  >
                    <input
                      style="
                        min-height: calc(1.5em + 0.75rem + 6px);
                        box-sizing: border-box;
                        height: 43px;
                        border: 1px solid #979797;
                        border-radius: 6px;
                        background-color: #ffffff;
                      "
                      type="number"
                      placeholder="Value"
                      @click="
                        rangeValidationWrong = false;
                        toggleValidation();
                      "
                      @blur="checkGreater($event, item, index)"
                      required="true"
                      :disabled="
                        remainingTypeListToShow.length > 0
                          ? disableTheSelected[index]
                          : true
                      "
                      v-model="item.value"
                      class="form-control"
                      id="dailyBudget"
                      onkeydown="javascript: return event.keyCode == 69 ? false : true"
                    />
                  </div>
                  <div
                    class="col-md-1"
                    v-if="
                      item.type &&
                      item.type.attr_data_type &&
                      item.type.attr_data_type == 'number' &&
                      item.condition &&
                      (item.condition.id == 'range' ||
                        item.condition.id == 'notinrange')
                    "
                    style="padding-right: 0px"
                  >
                    <input
                      style="
                        min-height: calc(1.5em + 0.75rem + 6px);
                        box-sizing: border-box;
                        height: 43px;
                        border: 1px solid #979797;
                        border-radius: 6px;
                        background-color: #ffffff;
                      "
                      type="number"
                      @click="
                        rangeValidationWrong = false;
                        toggleValidation();
                      "
                      @blur="checkSmall($event, item, index)"
                      placeholder="Value"
                      required="true"
                      :disabled="disableTheSelected[index]"
                      v-model="item.value2"
                      class="form-control"
                      id="dailyBudget"
                      onkeydown="javascript: return event.keyCode == 69 ? false : true"
                    />
                  </div>
                  
                  <div class="col-md-1" v-if="
                      item.type &&
                      item.type.attr_data_type &&
                      item.type.attr_data_type == 'number' &&
                      item.condition &&
                      (item.condition.id == 'range' ||
                        item.condition.id == 'notinrange')
                    "></div>
                  <div
                    class="col-md-3"
                    v-if="
                      item.type &&
                      item.type.attr_data_type &&
                      item.type.attr_data_type == 'boolean'
                    "
                  >
                    <multiselect
                      v-model="item.value"
                      class="
                        form-control
                        multi-dropdown
                        select_filter
                        multiselect-overview
                      "
                      placeholder="Select"
                      deselectLabel
                      selectedLabel
                      selectLabel
                      :disabled="
                        remainingTypeListToShow.length > 0
                          ? disableTheSelected[index]
                          : true
                      "
                      :options="booleanList"
                      ref="multiselect"
                      openDirection="bottom"
                      @input="checkForCoob"
                    ></multiselect>
                  </div>
                  <div
                    v-if="item.type && item.type.is_of_attr"
                    class="col-md-2"
                  ></div>
                  <div
                    v-if="item.type && item.type.is_of_attr"
                    class="col-md-2"
                  ></div>
                  <div
                    style="margin-top: 10px; margin-left: 0px"
                    v-if="item.type && item.type.is_of_attr"
                    class="form-group row col-md-3"
                  >
                    <p class="" style="margin: 7px; margin-right: 10px">Of</p>
                    <div class="col-md-9">
                      <multiselect
                        @input="toggleValidation"
                        v-model="item.attribute"
                        class="
                          form-control
                          multi-dropdown
                          select_filter
                          multiselect-overview
                        "
                        placeholder="Select"
                        label="name"
                        deselectLabel
                        selectedLabel
                        selectLabel
                        :disabled="disableTheSelected[index]"
                        :options="
                          remainingTypeListToShow.length > 0
                            ? keywordAttributionList
                              ? keywordAttributionList
                              : []
                            : []
                        "
                        track-by="name"
                        ref="multiselect"
                        :multiple="false"
                        :taggable="false"
                        style="height: 0px"
                      ></multiselect>
                    </div>
                  </div>
                  <div
                    style="padding-top: 8px"
                    :style="
                      item.type && item.type.is_of_attr ? 'margin-top:10px' : ''
                    "
                  >
                    <div
                      class="del-icon-outer"
                      style=""
                      v-if="
                        !(automationId == 'null' && conditionList.length < 1) &&
                        item.type &&
                        item.value &&
                        item.condition &&
                        ((item.value2 && item.condition.id == 'range') ||
                          item.condition.id != 'range')
                      "
                      @click="removeConditionFromList(index, item.type)"
                    >
                      <span style="" class="del-icon-inner">x</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              :key="'prefilledActions_' + index"
              class="form-group row"
              style="margin-bottom:0px"
              v-if="((conditionList.length != cloneOfTypeList.length &&
                    index == conditionList.length - 1 &&
                    item.type &&
                    (item.value.length ||
                      item.condition.id == 'ispresent' ||
                      item.condition.id == 'isnotpresent') &&
                    item.condition &&
                    ((item.value2 && item.condition.id == 'range') ||
                      item.condition.id != 'range') &&
                    source &&
                    typeOfOperation != 'OR')||(
                    conditionList.length != cloneOfTypeList.length &&
                    index == conditionList.length - 1 &&
                    item.type &&
                    (item.value.length ||
                      item.condition.id == 'ispresent' ||
                      item.condition.id == 'isnotpresent') &&
                    item.condition &&
                    ((item.value2 && item.condition.id == 'range') ||
                      item.condition.id != 'range') &&
                    source &&
                    typeOfOperation != 'AND'))"
            >
              <div class="col-md-2"></div>
              <div class="row col-md-10" style="margin-top:16px;">
                <div
                  @click="addConditionToList(item.type, index, 'AND')"
                  v-if="
                    conditionList.length != cloneOfTypeList.length &&
                    index == conditionList.length - 1 &&
                    item.type &&
                    (item.value.length ||
                      item.condition.id == 'ispresent' ||
                      item.condition.id == 'isnotpresent') &&
                    item.condition &&
                    ((item.value2 && item.condition.id == 'range') ||
                      item.condition.id != 'range') &&
                    source &&
                    typeOfOperation != 'OR'
                  "
                  class="del-icon-outer"
                  style="margin-left: 15px"
                >
                  <span style="" class="del-icon-inner">AND</span>
                </div>
                <div
                  @click="addConditionToList(item.type, index, 'OR')"
                  v-if="
                    conditionList.length != cloneOfTypeList.length &&
                    index == conditionList.length - 1 &&
                    item.type &&
                    (item.value.length ||
                      item.condition.id == 'ispresent' ||
                      item.condition.id == 'isnotpresent') &&
                    item.condition &&
                    ((item.value2 && item.condition.id == 'range') ||
                      item.condition.id != 'range') &&
                    source &&
                    typeOfOperation != 'AND'
                  "
                  class="del-icon-outer"
                >
                  <span style="" class="del-icon-inner">OR</span>
                </div>
              </div>
            </div>
          </template>
          <div
            v-if="rangeValidationWrong && isShowTargetMeasure && source"
            class="form-group row"
            style="padding-left: 15px"
          >
            <div class="col-md-2"></div>
            <span class="no-data-style">Value1 should be less than value2</span>
          </div>
        </div>

        <div
          v-else-if="!isShowTargetMeasure"
          class="spinner-border mt-3"
          style="margin: auto; display: block"
        ></div>
        <div
          style="margin-top: 36px; margin-bottom: 0px"
          class="form-group row"
        >
          <label for="schedule" class="col-sm-2 col-form-label"
            >Run Schedule <sup>*</sup></label
          >
          <div class="row col-sm-9">
             <span
              v-if="runScheduleValidation"
              class="no-data-style col-md-12"
              style=""
              >Provide the required field</span
            >
            <div
              class="option_box ml-3"
              :class="
                executeOn && item && executeOn == item.id ? 'selected' : ''
              "
              @click="selectInputValue(item, 'Schedule options')"
              v-for="item in executeOnList"
              :key="item.id"
            >
              <p
                class="inner_text"
                :class="
                  executeOn && item && executeOn == item.id ? 'selected' : ''
                "
              >
                {{ item["name"] }}
              </p>
            </div>
            <div v-if="showHourly"
              style="box-sizing: border-box;
              height: 41px;
              width: 1px;
              border: 1px solid #979797;
              border-radius: 1px;
              background-color: #D8D8D8; margin:0px 13px">
            </div>
            <div
              v-if="showHourly"
              class="option_box"
              :class="
                executeOn && executeOn == 'hourly' ? 'selected' : ''
              "
              @click="selectInputValue({id:'hourly',name:'Hourly'}, 'Schedule options')"
            >
              <p
                class="inner_text"
                :class="
                  executeOn && executeOn == 'hourly' ? 'selected' : ''
                "
              >
                Hourly
              </p>
            </div>
          </div>
        </div>
        <div
          class="form-group row"
          v-if="showExecuteTimeList"
          style="margin-top: 28px; margin-bottom: 0px"
        >
          <div class="col-md-2"></div>

            <div v-if="showExecuteTimeList && executeOn=='weekly'" class="col-md-9 row" style="padding-right:0px">
              <span
              v-if="showExecuteTimeList && scheduleValidation"
              class="no-data-style col-md-12"
              style=""
              >Provide the required field</span
            >
              <div
                style="min-width:66px !important"
                class="option_box ml-3"
                :class="
                  matchIfExist(executeTime,item) ? 'selected' : ''
                "
                @click="selectWeekDayValue(item)"
                v-for="item in weekList"
                :key="item.id"
              >
                <p
                  class="inner_text"
                  :class="
                    matchIfExist(executeTime,item) ? 'selected' : ''
                  "
                  style="text-transform:capitalize"
                >
                  {{ item["id"] }}
                </p>
              </div>
            </div>
            <div class="col-md-5" style="padding-right: 0px" 
              v-else-if="showExecuteTimeList">
              <span
              v-if="showExecuteTimeList && scheduleValidation"
              class="no-data-style"
              style=""
              >Provide the required field</span
            >
            <multiselect
              @input="toggleValidation"
              v-model="executeTime"
              :options="executeTimeList"
              :multiple="true"
              ref="multiselect"
              label="name"
              track-by="id"
              :taggable="false"
              placeholder="Select"
              class="
                form-control
                multi-dropdown
                select_filter
                multiselect-overview
              "
            ></multiselect>
          </div>
        </div>

        
        <div v-if="source && source.name" style="border-bottom: 1px solid #979797;margin-top:30px;margin-right:25px"></div>
        <template
          v-if="isShowTargetMeasure && source"
        >
          <div class="form-group row" style="margin-top: 24px; margin-bottom: 0px">
            <label for="action" class="col-sm-2 guardrail_tooltip">Guardrail Action 
              <i class="fas fa-question-circle ml-2" 
                data-toggle="tooltip"
                :title="actionToolTip"
                style="cursor:pointer"
                data-placement="bottom" 
                trigger="hover focus"
              ></i>
            </label>
              <!-- //place action code here -->
              <AddEditGuardrailActionAutomation
                currentIndex="0"
                :isEdit="false"
                :automationList="selectedAutomationInArray"
                :actions="
                  selectedAutomationInArray && selectedAutomationInArray.length
                    ? selectedAutomationInArray[0]['actions']
                    : []
                "
                :initialActionsSaved="
                  selectedAutomationInArray && selectedAutomationInArray.length
                    ? JSON.parse(
                        JSON.stringify(selectedAutomationInArray[0]['actions'])
                      )
                    : []
                "
                :targetValue="JSON.stringify(source)"
                v-if="source && source.name"
                ref="addEditActions"
                @actionsAdded="actionsAdded"
                @updateActionsAdded="updateActionsAdded"
                :actionsToShow="
                  selectedAutomationInArray && selectedAutomationInArray.length
                    ? selectedAutomationInArray[0]['actions']
                    : []
                "
                @openPreviewPopUp="openPreviewPopUp"
                @actionExistInCreate='actionExistInCreate'
              />
            <PreviewTempForGuardrailModal
              v-if="
                previewTemplateData &&
                Object.keys(previewTemplateData).length > 0
              "
              :previewTemplateData="previewTemplateData"
              @closePopUp="closePopUp"
            />
          </div>
          <div class="form-group row" v-if="nullActionsExist">
            <div class="col-md-2"></div>
            <div class="col-md-4">
              <span class="no-data-style">Make a selection to proceed</span>
            </div>
          </div>
        </template>
        <div v-if="source && source.name" style="border-bottom: 1px solid #979797;margin-top:30px;margin-right:25px"></div>
        <!-- //place scope code here -->
        <template
          v-if="isShowTargetMeasure && source"
        >
          <div class="form-group row" style="margin-top: 24px; margin-bottom: 0px">
            <label for="action" class="col-sm-2">Scope
                <i class="fas fa-question-circle ml-2" 
                data-toggle="tooltip"
                
                
                data-placement="bottom" 
                :title="scopeToolTip"
                style="cursor:pointer"></i>
            </label>
            <div class="col-sm-10 scope_form" style="margin-bottom: 0px">
              <AddScopeComp
                :automationId="$route.params.guardrailId=='null'?'':$route.params.guardrailId"
                automationIndex = "null"
                ref="addEditScopes"
                :target="(JSON.parse(JSON.stringify(source)) || {}).name"
                :calledFrom='calledFrom'
                @scopeExistInCreate='scopeExistInCreate'
              />
          </div>
          </div>
          
        </template>
      </div>
      
      <div style="border-bottom: 1px solid #979797;margin-top:60px;margin-right:25px;"></div>
      <div class="guardrail-footer">
        <span class="btn-cancel" v-on:click="reset" @click="cancel()">
          Cancel
        </span>
        <button class="btn btn-save" @click="submit" id="submit" v-if="automationId!='null' || scopeExist && actionExist">
          <span class="text" v-if="automationId!='null'">Save</span>
          <span class="text" v-else-if="scopeExist && actionExist">Create</span>
        </button>
        <button v-else class="btn btn-save_as_draft" @click="submit" id="submit">
          <span class="text">Save As Draft</span>
        </button>
      </div>
    </form>
  </div>
</template>


<script>
import Multiselect from "vue-multiselect";
import ReusableComponent from "../Automation2/ReusableComponent.vue";
import AddEditGuardrailActionAutomation from "../Automation2/AddEditGuardrailActionAutomation.vue";
import PreviewTempForGuardrailModal from "@/components/templates/PreviewTempForGuardrailModal.vue";
import AddScopeComp from "@/components/add-guardrail/AddScopeComp"
export default {
  name: "AddEditGuardrail",
  components: {
    ReusableComponent,
    Multiselect,
    AddEditGuardrailActionAutomation,
    PreviewTempForGuardrailModal,
    AddScopeComp
  },
  props: ["automatsionId"],
  mounted() {
    const vm = this;
    vm.automationId = vm.$route.params.guardrailId || "null";
    vm.calledFrom = vm.$route.params.calledFrom || ''
    this.$store.dispatch("automation/getAttributeList", {}).then((res) => {
      vm.sourceList = res;
      if (vm.automationId != "null") {
        this.initialiseAutomationPopup();
      } else {
        if(vm.calledFrom){
          vm.setCalledFromValues(vm.calledFrom)
        }
        vm.showLoader = false;
      }
    });
    if (
      this.automationId &&
      this.automationId != "null" &&
      this.allAutomationList
    ) {
      this.selectedAutomationInArray = [];
      this.selectedAutomationInArray = this.allAutomationList.filter(
        (item) => item.id == this.automationId
      );
    }
    this.$store.dispatch("accounts/getCountryList").then((res) => {
      vm.countryList = res;
      let data = vm.countryList.find((e) => e.market_place == "US");
      let index = vm.countryList.indexOf(data);
      vm.countryList.splice(index, 1);
      vm.countryList.unshift(data);
    });
    this.tagSearchLoader = true;
    this.$store.dispatch("automation/getTagsList", { q: "" }).then((res) => {
      vm.tagOptions = res;
      // if(vm.tagData.length){
      // 	vm.tagOptions = vm.tagOptions.concat(vm.tagData)
      // 	vm.tagOptions = new Set(vm.tagOptions);
      // 	vm.tagOptions = Array.from(vm.tagOptions);
      // }

      vm.tagSearchLoader = false;
    });
    $("#tagData").attr("autocomplete", "off");
    this.tooltipCode()
  },
  watch: {
    targetType() {
      this.setRangeList(this.targetType);
    },
    sendNotification() {
      if (this.sendNotification) {
        this.addEmail();
      } else {
        this.emailList = [];
      }
    },
    source() {
      if (!this.source) {
        this.resetTargetData();
      }
    },
    typeList() {
      this.remainingTypeListToShow = JSON.parse(JSON.stringify(this.typeList));
    },
    conditionList() {},
  },
  data() {
    return {
      calledFrom:'',
      showHourly:false,
      scopeExist:false,
      actionExist:false,
      actionToolTip:'You can choose from actions the system will take on your behalf and/or to send notifications when your target measure has been met.',
      scopeToolTip:'The products or campaigns that you would like this guardrail to either notify or take action on.',
      conditionalRange:[
				{ id: ">", name: "Greater Than" },
				],
      automationId: "",
      selectedAutomationInArray: [{ id: "", actions: [] }],
      newAutomationId: "",
      previewTemplateData: {},
      nullActionsExist:false,

      cloneOfTarget: "",
      runScheduleValidation: false,
      conditionValidation: false,
      scheduleValidation: false,
      nameValidation: false,
      tagValidation: false,
      targetValidation: false,
      countryValidation: false,
      conditionList: [
        { type: "", condition: "", value: "", value2: "", attribute: "" },
      ],
      flag: false,
      sourceList: [],
      title: "",
      source: "",
      executeOn: "",
      typeList: [],
      cloneOfTypeList: [],
      remainingTypeListToShow: [],
      booleanList: ["TRUE", "FALSE"],
      executeOnList: [
        { id: "daily", name: "Daily" },
        { id: "weekly", name: "Weekly" },
        { id: "monthly", name: "Monthly" },
      ],
      integerList: [
        { id: "<", name: "<" },
        { id: ">", name: ">" },
        { id: "=", name: "=" },
        { id: "!=", name: "!=" },
        { id: "range", name: "Range" },
      ],
      rangeList: [],
      yearList: [
        { id: "jan", name: "January" },
        { id: "feb", name: "February" },
        { id: "mar", name: "March" },
        { id: "apr", name: "April" },
        { id: "may", name: "May" },
        { id: "jun", name: "June" },
        { id: "jul", name: "July" },
        { id: "aug", name: "August" },
        { id: "sep", name: "September" },
        { id: "oct", name: "October" },
        { id: "nov", name: "Novenber" },
        { id: "dec", name: "December" },
      ],
      weekList: [
        { id: "mon", name: "Monday" },
        { id: "tue", name: "Tuesday" },
        { id: "wed", name: "Wednesday" },
        { id: "thu", name: "Thursday" },
        { id: "fri", name: "Friday" },
        { id: "sat", name: "Saturday" },
        { id: "sun", name: "Sunday" },
      ],
      monthDateList: [
        { id: 1, name: 1 },
        { id: 2, name: 2 },
        { id: 3, name: 3 },
        { id: 4, name: 4 },
        { id: 5, name: 5 },
        { id: 6, name: 6 },
        { id: 7, name: 7 },
        { id: 8, name: 8 },
        { id: 9, name: 9 },
        { id: 10, name: 10 },
        { id: 11, name: 11 },
        { id: 12, name: 12 },
        { id: 13, name: 13 },
        { id: 14, name: 14 },
        { id: 15, name: 15 },
        { id: 16, name: 16 },
        { id: 17, name: 17 },
        { id: 18, name: 18 },
        { id: 19, name: 19 },
        { id: 20, name: 20 },
        { id: 21, name: 21 },
        { id: 22, name: 22 },
        { id: 23, name: 23 },
        { id: 24, name: 24 },
        { id: 25, name: 25 },
        { id: 26, name: 26 },
        { id: 27, name: 27 },
        { id: 28, name: 28 },
        { id: 29, name: 29 },
        { id: 30, name: 30 },
        { id: 31, name: 31 },
      ],
      valueList: [],
      showExecuteTimeList: false,
      executeTimeList: [],
      executeTime: [],
      showForm: false,
      showLoader: true,
      tagData: [],
      tagOptions: [],
      sendNotification: false,
      emailList: [],
      isShowTargetMeasure: true,
      disableTheSelected: [],
      keywordAttributionList: "",
      targetType: "",
      getValueTypeUrlLoader: false,
      tagSearchLoader: false,
      selectedTargetType: "",
      typeOfOperation: "",
      rangeValidationWrong: false,
      countryList: [],
      countryRangeList: [],
    };
  },
  computed: {
    allAutomationList: {
      get() {
        return this.$store.state.automation.automationList;
      },
    },
    vendorsList() {
      return this.$store.state.vendorList;
    },
    subTargetValue: {
      set(val) {
        this.$store.state.automation.subTargetValue = val;
      },
      get() {
        return this.$store.state.automation.subTargetValue;
      },
    },
    subTarget: {
      set(val) {
        this.$store.state.automation.subTarget = val;
        this.subTargetValue = null;
      },
      get() {
        return this.$store.state.automation.subTarget;
      },
    },
    campaignSelectedList: {
      get() {
        return this.$store.state.campaign.campaignSelectedList;
      },
      set(val) {
        this.$store.state.campaign.campaignSelectedList = val;
      },
    },
    campaignGroupSelectedList: {
      get() {
        return this.$store.state.campaign.campaignGroupSelectedList;
      },
      set(val) {
        this.$store.state.campaign.campaignGroupSelectedList = val;
      },
    },
    selectedProducts: {
      set(val) {
        this.$store.state.product.selectedProducts = val;
      },
      get() {
        return this.$store.state.product.selectedProducts;
      },
    },
  },
  methods: {
    setCalledFromValues(calledFrom){
      let tempSource = ''
      if(calledFrom=='campaign'){
        tempSource = {
          name: "Campaign",
        }
      }
      else if(calledFrom=='campaign_group'){
        tempSource = {
          name: "Campaign Group",
        };
      }
      else if(calledFrom=='asin'){
        tempSource = {
          name: "Product",
        };
      }
      if(tempSource){
        this.getTargetTypeList(tempSource)
      }
    },
    scopeExistInCreate(data){
      this.scopeExist = data 
    },
    actionExistInCreate(data){
      this.actionExist = data
    },
    matchIfExist(list,item){
      let match = list.findIndex(data=>data.id==item.id)
      if(match!=-1){
        return true
      }
      return false
    },
    selectWeekDayValue(item){
      let match = this.executeTime.findIndex(data=>data.id==item.id)
      if(match!=-1){
        this.executeTime.splice(match,1)
      }
      else{
        this.executeTime.push(JSON.parse(JSON.stringify(item)))
      }
      this.toggleValidation()
    },
    tooltipCode() {
      $(document).ready(function () {
        $('[data-toggle="tooltip"]').tooltip({
            template: '<div class="tooltip tooltip-custom" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
        })
      });
    },
    closePopUp() {
      this.previewTemplateData = {};
      // $("#previewModal").modal("hide")
    },
    openPreviewPopUp(data) {
      this.previewTemplateData = data;
      // $("#previewModal").modal("show");
    },
    checkSmall(event, item, index) {
      if (item.value) {
        if (
          parseInt(event.currentTarget.value) < parseInt(item.value) ||
          parseInt(event.currentTarget.value) == parseInt(item.value)
        ) {
          this.rangeValidationWrong = true;
          let data = this.conditionList;
          data[index].value2 = "";
          this.conditionList = JSON.parse(JSON.stringify(data));
        } else {
          this.rangeValidationWrong = false;
        }
      }
    },
    checkGreater(event, item, index) {
      if (item.value2) {
        if (
          parseInt(event.currentTarget.value) > parseInt(item.value2) ||
          parseInt(event.currentTarget.value) == parseInt(item.value2)
        ) {
          this.rangeValidationWrong = true;
          let data = this.conditionList;
          data[index].value = "";
          this.conditionList = JSON.parse(JSON.stringify(data));
        } else {
          this.rangeValidationWrong = false;
        }
      }
    },
    selectTAgsFromList() {
      this.tagValidation = false;
    },
    addValue(name, index) {
      this.conditionList[index].value = [];
      var pay = { name: name };
      this.valueList.push(pay);
      this.conditionList[index].value.push(pay);
    },
    updateSingleValue(data, index) {
      let dataClone = JSON.parse(JSON.stringify(this.conditionList[index]));
      dataClone.value = [];
      dataClone.value.push(data);
      this.conditionList.splice(index, 1, dataClone);
      // this.conditionList[index].value = []
      // this.conditionList[index].value.splice(index,1)
      // this.conditionList.splice(1,0)
      // this.conditionList[index].value.push(JSON.parse(JSON.stringify(data)))
      // this.conditionList.splice(1,0)
    },
    addMultiValue(name, index, type) {
      if (type == "singleselect") {
        let dataClone = JSON.parse(JSON.stringify(this.conditionList[index]));
        dataClone.value = [];
        this.conditionList.splice(index, 1, dataClone);
      }
      if (this.conditionList[index].value == "") {
        this.conditionList[index].value = [];
      }
      var pay = { name: name };
      this.valueList.push(pay);
      this.conditionList[index].value.push(pay);
    },
    resetValue(option, index) {
      if (option.length) {
        this.conditionList[index].value = option[option.length - 1];
      } else {
        this.conditionList[index].value = [];
      }
    },
    setRangeList(type) {
      console.log(this.source);

      this.rangeList = [];
      if (
        type == "multiselect" ||
        type == "single-select" ||
        type == "text" ||
        type == "singleselect"
      ) {
        if (
          this.selectedTargetType &&
          this.selectedTargetType == "ASIN Status"
        ) {
          this.rangeList = [{ id: "equal", name: "Equals" }];
        } else if (
          this.selectedTargetType &&
          this.selectedTargetType == "Amazon Choice Attribute"
        ) {
          this.rangeList = [
            { id: "ispresent", name: "is Present" },
            { id: "isnotpresent", name: "is not Present" },
            { id: "contains", name: "Contains" },
            { id: "notcontains", name: " Not contains" },
          ];
        } else if (
          this.selectedTargetType &&
          this.selectedTargetType == "Country Code"
        ) {
          this.rangeList = this.countryRangeList;
          // this.rangeList = [
          // 	{ id: "contains", name: "Contains" }
          // ]
        } else {
          this.rangeList = [
            { id: "startwith", name: "Starts with" },
            { id: "endwith", name: "Ends with" },
            { id: "contains", name: "Contains" },
            { id: "notcontains", name: "Not Contains" },
            { id: "equal", name: "Equals" },
            { id: "notequals", name: "Not Equals" },
          ];
        }
      } else if (type == "boolean") {
        this.rangeList = [{ id: "equal", name: "Equals" }];
      } else if (type == "is") {
        this.rangeList = [{ id: "is", name: "Is" }];
      } else {
        this.rangeList = [
          { id: "<", name: "Less Than" },
          { id: ">", name: "Greater Than" },
          { id: "=", name: "Equal To" },
          { id: "!=", name: "Not Equal To" },
          { id: "range", name: "Range" },
          { id: "notinrange", name: "Not In Range" },
        ];
      }
      this.conditionList.splice(0, 0);
    },
    onSelectRange(item) {
      if (this.selectedTargetType && this.selectedTargetType == "ASIN Status") {
        item.value = "ASIN Not Found";
        this.disableTheSelected.push(true);
      }
    },
    toggleValidation() {
      this.runScheduleValidation = false;
      this.nameValidation = false;
      this.tagValidation = false;
      this.countryValidation = false;
      this.targetValidation = false;
      this.scheduleValidation = false;
      this.conditionValidation = false;
      this.rangeValidationWrong = false;
    },
    updateRemainingTypeListToShow(typeListFromResponse) {
      this.remainingTypeListToShow = JSON.parse(
        JSON.stringify(typeListFromResponse)
      );
    },
    searchFromDb(searchText) {
      if (searchText != "") {
        let payload = {
          q: searchText,
        };
        this.tagSearchLoader = true;
        const vm = this;
        this.$store.dispatch("automation/getTagsList", payload).then((res) => {
          vm.tagOptions = res;
          if (vm.tagData.length) {
            vm.tagOptions = vm.tagOptions.concat(vm.tagData);
            vm.tagOptions = new Set(vm.tagOptions);
            vm.tagOptions = Array.from(vm.tagOptions);
          }

          vm.tagSearchLoader = false;
        });
      }
    },
    removeSelectedTypeValueFromList(selectedType) {
      for (var i = 0; i < this.remainingTypeListToShow.length; i++) {
        if (this.remainingTypeListToShow[i].name == selectedType.name) {
          this.remainingTypeListToShow.splice(i, 1);
        }
      }
    },
    addDeSelectedTypeValueIntoList(deSelectedType) {
      var duplicate = false;
      for (var i = 0; i < this.remainingTypeListToShow.length; i++) {
        if (this.remainingTypeListToShow[i].name == deSelectedType.name) {
          duplicate = true;
          break;
        }
      }
      if (!duplicate) {
        this.remainingTypeListToShow.push(deSelectedType);
      }
    },
    addConditionToList(selectedType, index, typeOfOperation) {
      this.typeOfOperation = typeOfOperation;
      if (!this.flag) {
        if (selectedType.name != "ASIN Status") {
          this.disableTheSelected.push(true);
        }
      }
      this.removeSelectedTypeValueFromList(selectedType);
      var conditionRow = {
        type: "",
        condition: "",
        value: "",
        value2: "",
        attribute: "",
      };
      this.conditionList.push(conditionRow);
      this.flag = false;
    },
    removeConditionFromList(index, deSelectedType) {
      this.disableTheSelected.pop();
      if (deSelectedType) {
        this.addDeSelectedTypeValueIntoList(deSelectedType);
      }
      this.conditionList.splice(index, 1);
      if (this.conditionList.length == 1 || this.conditionList.length == 0) {
        this.typeOfOperation = "";
      }
      if (this.conditionList.length < 1) {
        var conditionRow = {
          type: "",
          condition: "",
          value: "",
          value2: "",
          attribute: "",
        };
        this.conditionList.push(conditionRow);
      }
			this.updateHourlyOnConditionList(this.conditionList)
    },
    checkForCoob(item){
      this.$nextTick(()=>{
        this.updateHourlyOnConditionList(this.conditionList)
      })
    },
    updateHourlyOnConditionList(listItems){
      let coobTrue = []
      coobTrue = listItems.filter(item=>{
        if(item && Object.keys(item.type||{}).length && item.type['id']=="prev_day_oob" && item.value == 'TRUE' && (this.source && this.source.name =='Campaign')){
          return true
        }
      })
      if(coobTrue && coobTrue.length){
        this.showHourly =  true
        if(this.executeOn=='hourly'){
          this.executeOn = ''
          this.$nextTick(()=>{
            this.executeOn = JSON.parse(JSON.stringify('hourly'))
          })
        }
      }
      else{
        this.showHourly = false
        //reset the frequency schedule if its horly
        if(this.executeOn=='hourly'){
          this.selectInputValue(null,'Schedule options')
        }
      }
    },
    addEmail() {
      if (this.emailList.length < 3) {
        this.emailList.push("");
      }
    },
    addTags(tag) {
      this.tagValidation = false;
      this.tagSearchLoader = false;
      this.tagValidation = false;
      const tagIs = {
        name: tag,
      };
      this.tagData.push(tagIs);
      if (this.tagOptions == undefined) {
        this.tagOptions = [];
        this.tagOptions.push(tagIs);
      } else {
        this.tagOptions.push(tagIs);
      }
    },
    getAllAutomationsList() {
      //	this.$store.state.currentPageNumber = 1
      this.subTargetValue = null;
      this.subTarget = null;
      this.$store.dispatch("automation/getAutomations");
    },
    navigateToList(){
      this.$router.push({path:'/'+this.$route.params.type})
    },
    cancel(){
      if(!this.calledFrom){
        this.navigateToList()
      }
       else {
        this.campaignSelectedList = [];
        this.campaignGroupSelectedList = [];
        this.selectedProducts = [];
        this.$store.state.campaign.campaignSelectedList = [];
        this.$store.state.campaign.campaignGroupSelectedList = [];
        this.$store.state.campaign.campaignToAddToGroupList = [];
        this.$store.state.product.actionSelectionControl = false;
        this.$store.state.campaign.actionSelectioncampaignGroupControl = false;
        this.$store.state.campaign.actionSelectionControl = false;
        if (this.calledFrom == "campaign") {
          if (this.$store.state.refreshCampaign) {
            this.$store.state.refreshCampaign = false;
          } else {
            this.$store.state.calledFromCancel = true;
          }
          this.$router.push({ path: "/campaignList" });
        } else if (this.calledFrom == "campaign_group") {
          this.$store.state.calledFromCancel = true;
          this.$router.push({ path: "/campaignGroupList" });
        } else if (this.calledFrom == "asin") {
          this.$store.state.calledFromCancel = true;
          this.$router.push({ path: "/asinScraper" });
        }
      }
    },
    reset() {
      var conditionRow = {
        type: "",
        condition: "",
        value: "",
        value2: "",
        attribute: "",
      };
      (this.conditionList = []), this.conditionList.push(conditionRow);
      (this.title = ""),
        (this.source = ""),
        (this.executeOn = ""),
        (this.emailList = []),
        (this.executeTime = []);
      this.disableTheSelected = [];
      this.cloneOfTarget = [];
      this.toggle();
      //(this.type = ""),
      //(this.typeObj = ""),
      //(this.condition = ""),
      //(this.conditionObj = ""),
      //(this.value = ""),
      //(this.valueObj = ""),
    },
    toggle() {
      this.$emit("toggleModal");
    },
    initialiseAutomationPopup() {
      var payload = {
        id: this.automationId,
      };
      const vm = this;
      this.$store
        .dispatch("automation/getAutomationDataById", payload)
        .then((res) => {
          vm.title = res.title;
          vm.conditionList =
            JSON.parse(JSON.stringify(res.trigger)).length > 0
              ? JSON.parse(JSON.stringify(res.trigger))
              : [{ type: "", condition: "", value: "", value2: "" }];
          vm.typeOfOperation =
            vm &&
            vm.conditionList &&
            vm.conditionList[0] &&
            vm.conditionList[0].operation_type
              ? vm.conditionList[0].operation_type
              : "";
          let executedata = JSON.parse(res.execute_on);
          vm.executeOn = executedata.id.toString();
          if (executedata.name == "Yearly") {
            vm.showExecuteTimeList = true;
            vm.executeTimeList = vm.yearList;
            vm.executeTime = res.execution_time;
          } else if (executedata.name == "Monthly") {
            vm.showExecuteTimeList = true;
            vm.executeTimeList = vm.monthDateList;
            vm.executeTime = res.execution_time;
          } else if (executedata.name == "Weekly") {
            vm.showExecuteTimeList = true;
            vm.executeTimeList = vm.weekList;
            vm.executeTime = res.execution_time;
          }
          vm.sendNotification = res.send_notification;
          vm.emailList = res.email ? res.email.split(",") : [];
          vm.tagData = res.tags ? JSON.parse(res.tags) : [];
          let storedSourceList = JSON.parse(res.target);
          vm.source = storedSourceList
            ? vm.sourceList.find((s) => s.name === storedSourceList.name)
            : null;
          let payload = {
            entityType: JSON.parse(res.target).name,
          };
          vm.cloneOfTarget = JSON.parse(
            JSON.stringify(JSON.parse(res.target).name)
          );
          vm.isShowTargetMeasure = false;
          vm.$store
            .dispatch("automation/getAttributeList", payload)
            .then((resp) => {
              //vm.targetType = resp[0].attr_data_type;
              resp = JSON.parse(resp[0].name);
              vm.cloneOfTypeList = resp;
              vm.updateRemainingTypeListToShow(resp);
              for (let i = 0; i < res.trigger.length; i++) {
                vm.disableTheSelected.push(true);
                vm.flag = true;
                res.trigger[i].trigger = JSON.parse(res.trigger[i].trigger);
                vm.conditionList[i].type = res.trigger[i].trigger
                  ? res.trigger[i].trigger.type
                  : null;
                vm.removeSelectedTypeValueFromList(vm.conditionList[i].type);
                if (
                  res.trigger[i].trigger.type.attr_data_type == "integer" ||
                  res.trigger[i].trigger.type.attr_data_type == "float"
                ) {
                  //vm.rangeList = vm.integerList;
                }
                vm.conditionList[i].condition = res.trigger[i].trigger
                  ? res.trigger[i].trigger.condition
                  : null;
                vm.conditionList[i].value = res.trigger[i].trigger.value;
                vm.conditionList[i].value2 = res.trigger[i].trigger.value2;
                if (
                  vm.keywordAttributionList.length < 1 &&
                  res.trigger[i].trigger.type.is_of_attr
                ) {
                  vm.isShowTargetMeasure = true;
                  vm.conditionList[i].attribute = res.trigger[i].trigger
                    ? res.trigger[i].trigger.attribute
                    : null;
                  vm.keywordAttributionList =
                    typeof res.trigger[i].trigger.type.is_of_attr == "string"
                      ? JSON.parse(res.trigger[i].trigger.type.is_of_attr)
                      : res.trigger[i].trigger.type.is_of_attr;
                } else {
                  vm.isShowTargetMeasure = true;
                }
              }
              vm.updateHourlyOnConditionList(vm.conditionList)
            });
          vm.showForm = true;
          vm.showLoader = false;
        });
    },
    getObjectFromId(id, list) {
      var object = {};
      for (var i = 0; i < list.length; i++) {
        if (id == list[i].id) {
          object = list[i];
          break;
        }
      }
      return object;
    },
    getTargetTypeList(id) {
      this.toggleValidation();
      this.source = null;
      this.$nextTick(() => {
        this.source = JSON.parse(JSON.stringify(id));
      });
      if (id && id.name) {
        this.resetTargetData();
        this.isShowTargetMeasure = false;
        let payload = {
          entityType: id.name,
        };
        this.$store
          .dispatch("automation/getAttributeList", payload)
          .then((res) => {
            //this.targetType = res[0].attr_data_type;
            this.typeList = JSON.parse(res[0].name);
            this.cloneOfTypeList = JSON.parse(res[0].name);
            this.isShowTargetMeasure = true;
          });
      }
    },
    removeTarget(data, id) {
      if(data && data.id=="prev_day_oob"){
					this.showHourly = false
				}
    },
    selectInputValue(id, selection) {
      if (selection == "Schedule options") {
        this.executeTime = [];
        this.executeTimeList = [];
        this.executeOn = id ? id.id.toString() : "";
        this.updateExecuteTimeList(id);
      }
      this.toggleValidation();
    },
    resetTargetData() {
      this.typeList = [];
      this.cloneOfTypeList = [];
      //this.rangeList = [];
      this.valueList = [];
      this.disableTheSelected = [];
      var conditionRow = {
        type: "",
        condition: "",
        value: "",
        value2: "",
        attribute: "",
      };
      (this.conditionList = []), this.conditionList.push(conditionRow);
    },
    getTargetTypedata(data, index, item) {
      this.selectedTargetType = data.name;
      this.resetTarget(item, index);
      this.toggleValidation();
      if (data && data.id == "country") {
        this.countryRangeList = data.filterType;
      }
      if (data && data.is_of_attr) {
        this.keywordAttributionList = data.is_of_attr;
      }
      if (data) {
        this.conditionList[index].type = data;
      } else {
        this.conditionList[index].type = {};
      }

      this.conditionList[index].condition = "";

      this.targetType = (data || {}).attr_data_type;
      if (data && data.attr_data_type) {
        this.setRangeList(this.targetType);
      }

      if (data && data.value_type_url == "/vendor") {
        this.getValueTypeUrlLoader = true;
        const vm = this;
        this.$store.dispatch("getAllVendor").then((res) => {
          vm.valueList = res.filter((v) => v.name);
          vm.getValueTypeUrlLoader = false;
        });
      } else {
        this.valueList = [];
      }
			this.updateHourlyOnConditionList(this.conditionList)
    },
    resetTarget(item, index) {
      this.conditionList[index].type = [];
      this.conditionList[index].condition = [];
      this.conditionList[index].value = [];
    },
    selectExecuteTime() {},
    updateExecuteTimeList(obj) {
      if (obj) {
        if (obj.name == "Daily" || obj.name == "Hourly") {
          this.showExecuteTimeList = false;
        } else if (obj.name == "Weekly") {
          this.showExecuteTimeList = true;
          this.executeTimeList = this.weekList;
        } else if (obj.name == "Monthly") {
          this.showExecuteTimeList = true;
          this.executeTimeList = this.monthDateList;
        } else if (obj.name == "Yearly") {
          this.showExecuteTimeList = true;
          this.executeTimeList = this.yearList;
        }
      } else {
        this.showExecuteTimeList = false;
        this.executeTimeList = [];
        this.executeTime = [];
      }
    },
    actionsAdded() {
      // $("#addEditAutomation").modal("hide");
      this.showLoader = false;
      this.reset();
      this.navigateToList()
      // this.getAllAutomationsList();
    },
    updateActionsAdded() {
      const vm = this;
      $("#addEditAutomation").modal("hide");
      if (vm.cloneOfTarget != vm.source.name) {
        var data = { id: vm.automationId };
        vm.$store
          .dispatch("automation/updateActionAsPerTarget", data)
          .then((res) => {
            vm.showLoader = false;
            vm.getAllAutomationsList();
            vm.reset();
          });
      } else {
        vm.getAllAutomationsList();
        vm.reset();
      }
    },
    submit() {
      if (!this.title.trim()) {
        this.nameValidation = true;
      } else if (!this.executeOn) {
        this.runScheduleValidation = true;
      } else if (this.showExecuteTimeList && this.executeTime.length < 1) {
        this.scheduleValidation = true;
      } else if (!this.source) {
        this.targetValidation = true;
      } else if (
        (this.conditionList.length < 2 &&
          (!this.conditionList[0].type ||
            (!this.conditionList[0].condition &&
              !this.conditionList[0].type.action) ||
            (!this.conditionList[0].value &&
              this.conditionList[0].condition.id != "ispresent" &&
              this.conditionList[0].condition.id != "isnotpresent") ||
            (this.conditionList[0].condition.id == "range" &&
              !this.conditionList[0].value2) ||
            (this.conditionList[0].condition.id == "notinrange" &&
              !this.conditionList[0].value2) ||
            (this.conditionList[0].type.is_of_attr &&
              !this.conditionList[0].attribute))) ||
        (this.conditionList[0].value &&
          Array.isArray(this.conditionList[0].value) &&
          this.conditionList[0].value.length == 0 &&
          this.conditionList[0].condition.id != "ispresent" &&
          this.conditionList[0].condition.id != "isnotpresent") ||
        (this.conditionList[0].condition &&
          Array.isArray(this.conditionList[0].condition) &&
          this.conditionList[0].condition.length == 0)
      ) {
        this.conditionValidation = true;
      }
      // bypass mandatory tag validation
      // else if (this.tagData.length < 1) {
      //   this.tagValidation = true;
      // }
      else {
        var vm = this;
        let tempList = this.executeOnList
        tempList.push({id:"hourly", name:"Hourly"})
        let executeTimeObj = tempList.find(
          (t) => t.id == this.executeOn
        );
        let hourlyIndex = tempList.map(x=>x.name).indexOf("Hourly");
        tempList.splice(hourlyIndex,1);
        this.conditionList.forEach((condition, index) => {
          if (condition.id) {
            vm.conditionList[index] = JSON.parse(
              vm.conditionList[index].trigger
            );
          } else if (
            (condition.condition == "" && !condition.type.action) ||
            condition.type == "" ||
            (condition.value == "" &&
              condition.condition.id != "ispresent" &&
              condition.condition.id != "isnotpresent")
          ) {
            vm.conditionList.splice(index, 1);
          }
        });
        var payload = {
          title: this.title,
          executeOn: executeTimeObj,
          executeTime: this.executeTime,
          target: this.source,
          trigger: this.conditionList,
          email: this.emailList,
          sendNotification: this.sendNotification,
          //skipping tags
          tags: this.tagData,
          typeOfOperation: this.typeOfOperation,
        };
        // if(this.showHourly && executeTimeObj.id=='hourly' && this.source && this.source.name =='Campaign'){
        //   payload['is_hourly'] = 'True'
        // }
        this.automationId != "null" ? (payload["id"] = this.automationId) : "";
        let nullActions = true
        nullActions = this.$refs["addEditActions"].ifNullExist();
        this.nullActionsExist = false
        if(nullActions){
          this.nullActionsExist = true
          return
        }
        this.showLoader = true;
        this.$store
          .dispatch("automation/addUpdateAutomation", payload)
          .then((response) => {
            //update case
            if (vm.automationId && vm.automationId != "null") {
              vm.$refs["addEditActions"].submitAction(vm.automationId);
            }
            //add case
            else {
              if (response && response.id) {
                //save actions call if automation id is there
                // vm.newAutomationId = response.id
                vm.selectedAutomationInArray = [{ id: "", actions: "" }];
                vm.selectedAutomationInArray[0]["id"] = response.id;
                vm.$refs["addEditActions"].submitAction(response.id);
                vm.$refs["addEditScopes"].addNewScopes(response.id)
              } else {
                console.log("failed to save actions");
                vm.actionsAdded();
              }
            }
          });
      }
    },
  },
};
</script>
<style lang="scss">
.tooltip-custom {
  opacity:1 !important;
  .arrow{
  }
    .tooltip-inner {
      min-width:171px !important;
      width:171px !important;
      min-height:60px !important;
      border-radius:4px !important;
      color: #FFFFFF;
      font-family: Roboto;
      font-size: 10px;
      letter-spacing: -0.02px;
      line-height: 11px;
      text-align: center;
      padding-top:7.5px !important;
    }
}
.newg_form {
  .block_events {
    pointer-events: none;
  }
  .del-icon-outer {
    box-sizing: border-box;
    height: 30px;
    border: 1px solid #115e67;
    border-radius: 6px;
    text-align: center;
    margin-left: 13px;
    padding-left: 10px;
    padding-right: 10px;
    cursor: pointer;
    min-width: 31px;
    .del-icon-inner {
      height: 19px;
      color: #115e67;
      font-family: "Nunito Sans";
      font-size: 14px;
      font-weight: bold;
      letter-spacing: -0.03px;
      line-height: 19px;
      text-align: center;
      min-width: 31px;
    }
  }
  .input-overview {
    box-sizing: border-box;
    height: 43px;
    border: 1px solid #979797;
    border-radius: 6px;
    background-color: #ffffff;
  }
  .multiselect-overview {
    box-sizing: border-box;
    height: 43px !important;
    border: 1px solid #979797;
    border-radius: 6px;
    background-color: #ffffff;
  }
  .guardrail-footer {
    height: 91px;
    text-align:center;
    padding-top:24px;
    .btn-save_as_draft{
      box-sizing: border-box;
      height: 40px;
      width: 118px;
      border: 2px solid #FFBF3F;
      border-radius: 21.5px;
      background-color: rgba(255,191,63,0.3);
      .text{
        height: 19px;
        width: 108px;
        color: #333333;
        font-family: "Nunito Sans";
        font-size: 14px;
        font-weight: bold;
        letter-spacing: -0.03px;
        line-height: 19px;
        text-align: center;
      }
    }
    .btn-save {
      height: 38px;
      width: 84px;
      border-radius: 21.5px;
      background-color: #ffbf3f;
      .text {
        height: 19px;
        width: 106px;
        color: #333333;
        font-family: "Nunito Sans";
        font-size: 14px;
        font-weight: bold;
        letter-spacing: -0.03px;
        line-height: 19px;
        text-align: center;
      }
    }
    .btn-cancel {
      cursor: pointer;
      height: 19px;
      width: 70px;
      color: #333333;
      font-family: "Nunito Sans";
      font-size: 14px;
      font-weight: bold;
      letter-spacing: -0.03px;
      line-height: 19px;
      text-align: center;
    }
  }

  .modal_body {
    padding-left: 0px !important;
    padding-right: 0px !important;
    padding-top: 24px !important;
    padding-bottom: 60px !important;
  }
  .header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    border-bottom: 1px solid #dee2e6;
    padding-top: 18px;
    padding-bottom: 14px;
    button {
      height: 21px;
      width: 22px;
      font-weight: bold;
    }
  }
  .heading {
    color: #333333;
    font-family: "Nunito Sans";
    font-size: 22px;
    font-weight: bold;
    letter-spacing: 0.03px;
  }
  label {
    color: #333333;
    font-family: "Nunito Sans";
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0.02px;
    line-height: 22px;
  }
  .scope_form{
    label{
      line-height:19px !important;
      font-size:14px !important;
      font-weight:normal !important;
    }
  }
  .option_box {
    box-sizing: border-box;
    height: 43px;
    min-width: 105px;
    border: 1px solid #115e67;
    border-radius: 6px;
    background-color: #ffffff;
    &.selected {
      background-color: #115e67;
    }
    .inner_text {
      cursor: pointer;
      color: #115e67;
      font-family: "Nunito Sans";
      font-size: 14px;
      font-weight: bold;
      letter-spacing: -0.03px;
      line-height: 42px;
      text-align: center;
      padding-left: 10px;
      padding-right: 10px;
      &.selected {
        color: #ffffff !important;
      }
    }
  }
}
input#dailyBudget::placeholder {
  color: #adadad;
  display: inline-block;
  margin-bottom: 10px;
  padding-top: 2px;
}
.product-tags {
  .multiselect__tag {
    text-transform: none !important;
  }
}
.product-tags {
  .multiselect__single {
    text-transform: none !important;
    overflow: hidden;
  }
}
.product-tags {
  .multiselect__option span {
    text-transform: none !important;
  }
}
</style>
